module.exports = __webpack_public_path__ + "img/d-gold-icon.95bc44f9.svg";